<template>
  <v-icon
    class="material-icons"
    :style="{color: color}"
    v-bind:class="{'ico': fontItems[icode] }"
    ref="icon"
  >
    <slot></slot>
  </v-icon>
</template>
<script>
import _icon from '@/helpers/iconHelper';

export default {
  name: 'FontIcon',
  data() {
    return {
      fontItems: _icon.customIcons,
      icode: null
    };
  },
  props: {
    color: {
      default: () => null
    }
  },
  mounted() {
    this.icode = this.$refs.icon.$el.innerHTML;
  }
};
</script>
<style lang="stylus">
.ico {
  font-family: icomoon !important;
}
</style>
